import React from 'react';

import { InfoCard } from '@eika/card';
import { Link, LinkType } from '@eika/link';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import { Content } from '../../../../components/shared/Content';
import { useConfig } from '../../../../defaultConfig';
import useTranslation from '../../../../hooks/useTranslation';

const EmptyListContent: React.FC = () => {
    const translated = useTranslation();
    const { frontPageLink } = useConfig();
    return (
        <Content dataTestId="outbox-content">
            <InfoCard
                className="sgw-layout-item sgw-layout-item__full-width"
                asHeader
                img={<RichIcon type={RichIconTypes.SOMMERFUGLER_2} />}
                data-testid="no-payments-for-approval-image"
            >
                <InfoCard.TitleH2>{translated.outbox.emptyList}</InfoCard.TitleH2>
            </InfoCard>
            <div className="empty-list-content__link-wrapper">
                <Link href={frontPageLink?.url} linkType={LinkType.BUTTON_STANDARD_POSITIVE}>
                    {translated.outbox.mainPageLink}
                </Link>
            </div>
        </Content>
    );
};

export default EmptyListContent;
